@let filesCollection = filesEc;
@let management = filesCollection.management;
@let managementSelectors = management.selectors;
@let loading = managementSelectors.isLoading.asSignal();
@let agents = managementSelectors.agents.asSignal();
@let hasNoAgents = agents.length === 0;
@let isAgentMode = managementSelectors.isAgentMode.asSignal();
@let isSharedMode = managementSelectors.isSharedMode.asSignal();
@let fileOperations = filesCollection.fileOperations;

<atn-ds-page [scrollable]="true">
  <atn-ds-page-header
    pageHeader
    name="Knowledge Bases"
  />

  @if (loading) {
    <atn-ds-loader
      type="page"
      message="Loading knowledge-base documents"
    />
  } @else if (hasNoAgents) {
    <atn-admin-knowledge-bases-page-shared-tab />
  } @else {
    <atn-ds-floating-horizontal-tabs
      (selectedTabChange)="
        management.actions.selectMode
          .from('Admin.KnowledgeBases.Workspace.Selected')
          .dispatch(
            $event?.index === 1 ? selectionModes.Agent : selectionModes.Shared
          )
      "
    >
      <ng-template
        atnDsTab
        name="Shared documents"
        [isInitiallySelected]="isSharedMode"
      >
        <atn-admin-knowledge-bases-page-shared-tab />
      </ng-template>

      <ng-template
        atnDsTab
        name="Agent-specific documents"
        [isInitiallySelected]="isAgentMode"
      >
        <atn-admin-knowledge-bases-page-agent-tab />
      </ng-template>
    </atn-ds-floating-horizontal-tabs>
  }
</atn-ds-page>

@let deletingFile = fileOperations.selectors.deletingFile.asSignal();
@let deleteConfirmationDescription =
  fileOperations.selectors.deleteConfirmationDescription.asSignal();
@let deleteError = fileOperations.selectors.deletionError.asSignal();
@let deleting = fileOperations.selectors.isDeleting.asSignal();

@if (deletingFile) {
  <atn-ds-confirmation-overlay
    title="Delete document"
    [description]="deleteConfirmationDescription"
    [error]="deleteError"
    [loading]="deleting"
    [validation]="deletingFile.name"
    confirmButtonText="Delete"
    (cancel)="
      fileOperations.actions.cancelDeletion
        .from('Admin.KnowledgeBases.Delete.Cancelled')
        .dispatch()
    "
    (confirm)="
      fileOperations.actions.confirmDeletion
        .from('Admin.KnowledgeBases.Delete.Confirmed')
        .dispatch()
    "
  />
}
